import React, { useState } from 'react';
import styles from './PreviewRelatedObjects.module.scss';
import { Icon, Popconfirm, Spin } from 'antd';
import cn from 'classnames';
import useDocsIdByBind from '../../queries/useDocsIdByBind';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import CreateConnection from '../CreateConnection/CreateConnection';
import useAllowedEntityQuery from '../../queries/useAllowedEntityQuery';
import moment from 'moment';
import useDocsBindDelete from '../../mutation/useDocsBindDelete';

const RelatedObject = ({ item, isActive = false, onChangeActive }) => {
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const { documentId } = useSelector(documentDrawerSelector);

  const { onBindDocsDelete, isLoading } = useDocsBindDelete();

  const handleConfirm = () => {
    onBindDocsDelete({
      documentId,
      bindEntityTypeId: item?.entityType?.id,
      bindEntityId: item?.id,
    });
  };

  const showDeleteBtn = Number(userInfo?.WorkerId) === item?.workerId;

  return (
    <div
      className={cn(styles.item, {
        [styles.activeItem]: isActive,
      })}
    >
      <Icon
        type="file"
        style={{ color: '#3378F9', fontSize: '20px', marginTop: 5 }}
      />
      <div className={styles.contentItem}>
        <div className={styles.nameItem}>
          {item?.type?.name} {item?.documentNumber || ''} от{' '}
          {moment(item?.bindDateTime).format('DD.MM.YYYY')}
        </div>
        <div className={styles.typeItem}>{item?.entityType?.name}</div>
        <div className={styles.statusItem}>Статус: {item?.status?.name}</div>
      </div>
      {showDeleteBtn && (
        <div className={styles.iconBox}>
          <Popconfirm
            placement="topRight"
            title={
              <p>
                Вы уверены, что хотите отвязать{' '}
                <strong>{item?.entityType?.name}</strong> от{' '}
                <strong>
                  {moment(item?.bindDateTime).format('DD.MM.YYYY')}
                </strong>
              </p>
            }
            onConfirm={handleConfirm}
            okText="Да"
            cancelText="Нет"
          >
            <Icon
              type={isLoading ? 'loading' : 'delete'}
              className={styles.deleteIcon}
            />
          </Popconfirm>
        </div>
      )}
    </div>
  );
};

const PreviewRelatedObjects = ({ onClose }) => {
  const [activeObj, setActiveObj] = useState(null);

  const { documentId, formValues } = useSelector(documentDrawerSelector);

  const { data: relatedObjects = [], isFetching } = useDocsIdByBind(documentId);

  const typeId = formValues?.type?.id;

  const { data: allowedEntity = [], isFetching: isAllowedEntityFetching } =
    useAllowedEntityQuery(typeId, {
      enabled: !!typeId,
      staleTime: Infinity,
    });

  const handleChangeActive = (value) => {
    setActiveObj(value);
  };

  return (
    <div className={styles.previewPanel}>
      <div className={styles.header}>
        {isFetching ? (
          <Spin style={{ margin: 'auto' }} />
        ) : (
          <>
            <div className={styles.title}>
              <span className={styles.name}>Связанные объекты</span>
              <Icon
                type="close"
                className={styles.closeBtn}
                onClick={() => onClose(false)}
              />
            </div>
            <div className={styles.countRelatedObjects}>{``}</div>
            <div className={styles.description}>
              Создайте или свяжите объект с ранее созданным
            </div>
          </>
        )}
      </div>
      <div className={styles.body}>
        {isFetching ? (
          <Spin style={{ margin: 'auto' }} />
        ) : (
          relatedObjects?.map((item) => (
            <RelatedObject
              key={item.id}
              item={item}
              onChangeActive={handleChangeActive}
              isActive={activeObj === item.id}
            />
          ))
        )}
      </div>
      <CreateConnection
        allowedEntity={allowedEntity}
        isAllowedEntityFetching={isAllowedEntityFetching}
        onClose={onClose}
      />
      {/* <div className={styles.footer}>
        <RoundedButton
          type="primary"
          text="Связать"
          className={styles.bindBtn}
          disabled={!activeObj}
        />
      </div> */}
    </div>
  );
};

export default PreviewRelatedObjects;
